'use client';
import { isUndefined } from '@s7/utils';
import { assemble } from '../assemble/assemble.js';

function variadic(fn, cache, serializer) {
    const args = Array.prototype.slice.call(arguments, 3);
    const cacheKey = serializer(args);
    let computedValue = cache.get(cacheKey);
    if (isUndefined(computedValue)) {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
const strategyVariadic = function(fn, options) {
    const { cache, serializer } = options || {};
    return assemble(fn, this, variadic, cache == null ? void 0 : cache.create(), serializer);
};

export { strategyVariadic, variadic };
//# sourceMappingURL=variadic.js.map
